/**
 * Object Interface
 */
export interface ObjectInterface {
  i?: number | null;
  Caldwell_Messier: string;
  "WISE Objects": string;
  L: string | number;
  B: string | number;
  Longitude: string | number;
  Latitude: string | number;
  "size in degrees": string | number | null;
  "HST image": string;
  Orientation: string | null | number;
  "Pending Caldwell add.": string | null | number;
  Birthday: string | null | number;
  Category: string | null | number;
  n: string | null | number;
  date: string | null | number;
  year: string | null | number;
  name: string | null | number;
  text: string | null | number;
  url: string | null | number;
}

/*
 Modify Lat Long to suit x, y coordinates
*/
export const objectModification = (item: ObjectInterface): ObjectInterface => {
  item.Latitude = Number(String(item.Latitude).replace(/[^0-9.-]/g, ""));
  item.Longitude = Number(String(item.Longitude).replace(/[^0-9.-]/g, ""));
  if (item.Latitude > 0) {
    item.Latitude = -Math.abs(Number(item.Latitude));
  } else {
    item.Latitude = Math.abs(Number(item.Latitude));
  }
  return item;
};